import { browserHistory } from 'react-router';

export function redirectToApplicationPage(property_id, application_id, renewal_id) {
  if (!application_id) {
    browserHistory.push(`/tenant_application?property_id=${property_id}`);
  } else if (renewal_id) {
    browserHistory.push(
      `/tenant_application?property_id=${property_id}&application_id=${application_id}&renewal_id=${renewal_id}`
    );
  } else {
    browserHistory.push(
      `/tenant_application?property_id=${property_id}&application_id=${application_id}`
    );
  }
}
